<template>
	<div class="view-claim">
		<Modal
			:show="showReportIncident"
			content_class="col-12 col-md-9 col-lg-8 col-xl-7 confirm-modal"
		>
			<template slot="content">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">Report Claim</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showReportIncident', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="content">
						<div class="steps">
							<div class="page" v-if="report_page === 1">
								<div class="forms">
									<div class="h4">Select Policy</div>

									<div class="page-box">
										<div class="scroll-content">
											<scrollbar>
												<div
													class="select-card policy card card-details"
													v-for="(
														policy, p
													) in claim_policies"
													:key="p"
													@click="
														$store.commit(
															'selected_policy',
															policy.policy_system_ref,
														);
														$store.commit(
															'selected_policy_full',
															policy,
														);
													"
													:class="{
														selected:
															policy.policy_system_ref ===
															selected_policy,
													}"
												>
													<div class="clearfix">
														<div class="f-l">
															<img
																:src="
																	policy.logo &&
																	policy.logo !==
																		''
																		? api.getDomain() +
																			policy.logo
																		: '/img/logo-1.png'
																"
																alt=""
																class="image"
															/>
														</div>
														<div class="f-l">
															<div class="name">
																{{
																	policy.product_name
																}}
															</div>
															<div class="amount">
																{{
																	policy.currency_code
																}}
																{{
																	utils.numberWithCommas(
																		Math.round(
																			policy.premium_amount *
																				100,
																		) / 100,
																	)
																}}
															</div>
															<div
																class="cover-date"
															>
																Cover Start :
																{{
																	policy.cover_start_date
																}}
																- End :
																{{
																	policy.cover_end_date
																}}
															</div>
															<div
																class="cover-date"
															>
																Purchase Date
																{{
																	policy.purchase_date
																}}
															</div>
														</div>
													</div>
												</div>
											</scrollbar>
										</div>
									</div>
								</div>
								<div class="buttons">
									<div
										class="btn btn-primary btn-long"
										:disabled="loading"
										@click="moveToNextReport()"
									>
										Next
										<div class="lds-ring" v-show="loading">
											<div></div>
											<div></div>
											<div></div>
											<div></div>
										</div>
									</div>
								</div>
							</div>
							<div class="page" v-if="report_page === 2">
								<div class="forms">
									<div class="h4">Select Risk</div>

									<div class="page-box">
										<div class="scroll-content">
											<scrollbar>
												<div
													class="select-card policy card card-details"
													v-for="(risk, p) in risks"
													:key="p"
													@click="
														$store.commit(
															'selected_risk',
															risk.riskRef,
														);
														$store.commit(
															'selected_risk_ref',
															risk.riskRef,
														);
														$store.commit(
															'selected_risk_full',
															risk,
														);
													"
													:class="{
														selected:
															risk.riskRef ===
															selected_risk,
													}"
												>
													<div class="clearfix">
														<div class="f-l">
															<div class="name">
																Reference:
																{{
																	risk.riskRef
																}}
															</div>
															<div class="name">
																Sum Assured:
																{{
																	risk.riskValue
																}}
															</div>
															<div
																class="cover-date"
															>
																Premium Amount:
																{{
																	risk.totalPremium
																}}
															</div>
														</div>
													</div>
												</div>
											</scrollbar>
										</div>
									</div>
								</div>
								<div class="buttons">
									<div class="row">
										<div class="col-md-6">
											<div
												class="btn btn-primary btn-long"
												:disabled="loading"
												@click="moveToPreviousReport()"
											>
												Previous
											</div>
										</div>
										<div class="col-md-6">
											<div
												class="btn btn-green btn-long"
												:disabled="loading"
												@click="moveToNextReport()"
											>
												Next
												<div
													class="lds-ring"
													v-show="loading"
												>
													<div></div>
													<div></div>
													<div></div>
													<div></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="page" v-if="report_page === 3">
								<div class="forms">
									<div class="h4">Select Claim Type</div>

									<div class="page-box">
										<div class="scroll-content">
											<scrollbar>
												<div
													class="select-card claim-type card card-details"
													v-for="(
														claim_type, c
													) in claim_types"
													:key="c"
													@click="
														$store.commit(
															'selected_claim_type',
															claim_type.claim_type_code,
														);
														$store.commit(
															'selected_claim_type_name',
															claim_type.claim_type_name,
														);
													"
													:class="{
														selected:
															claim_type.claim_type_code ===
															selected_claim_type,
													}"
												>
													<div class="clearfix">
														<div class="f-l">
															<img
																:src="
																	claim_type.claim_type_icon &&
																	claim_type.claim_type_icon !==
																		''
																		? api.getDomain() +
																			claim_type.claim_type_icon
																		: '/img/logo-1.png'
																"
																alt=""
																class="image"
															/>
														</div>
														<div class="f-l">
															<div class="name">
																{{
																	claim_type.claim_type_name
																}}
															</div>
															<div class="desc">
																{{
																	claim_type.claim_type_description
																}}
															</div>
														</div>
													</div>
												</div>
											</scrollbar>
										</div>
									</div>
								</div>
								<div class="buttons">
									<div class="row">
										<div class="col-md-6">
											<div
												class="btn btn-primary btn-long"
												:disabled="loading"
												@click="moveToPreviousReport()"
											>
												Previous
											</div>
										</div>
										<div class="col-md-6">
											<div
												class="btn btn-green btn-long"
												:disabled="loading"
												@click="moveToNextReport()"
											>
												Next
												<div
													class="lds-ring"
													v-show="loading"
												>
													<div></div>
													<div></div>
													<div></div>
													<div></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="page" v-if="report_page === 4">
								<div class="forms">
									<div
										class="form-box"
										v-if="
											claim_report_fields.forms &&
											claim_report_fields.forms.length > 0
										"
									>
										<Form
											v-show="
												selected_claim_type_name ===
												benefit_name
											"
											classBinding="row"
											:ref="
												ClaimModel.forms.benefits_form
													.name
											"
											:forms="
												ClaimModel.forms.benefits_form
													.forms
											"
											:form_data="
												ClaimModel.forms.benefits_form
													.data
											"
										/>
										<Form
											classBinding="row"
											:ref="claim_report_fields.name"
											:forms="claim_report_fields.forms"
											:form_data="
												claim_report_fields.data
											"
											@file-selected="uploadFilesClaim"
										/>
									</div>

									<div class="white-content" v-else>
										<div class="title">
											No Form Available
										</div>
									</div>
								</div>
								<div class="buttons">
									<div class="row">
										<div class="col-md-6">
											<div
												class="btn btn-primary btn-long"
												:disabled="loading"
												@click="moveToPreviousReport()"
											>
												Previous
											</div>
										</div>
										<div class="col-md-6">
											<div
												class="btn btn-green btn-long"
												:disabled="loading"
												@click="
													moveToNextReport({
														claimFields:
															$refs[
																claim_report_fields
																	.name
															],
														benefit_form:
															$refs[
																ClaimModel.forms
																	.benefits_form
																	.name
															],
													})
												"
											>
												Next
												<div
													class="lds-ring"
													v-show="loading"
												>
													<div></div>
													<div></div>
													<div></div>
													<div></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="page" v-if="report_page === 5">
								<div class="confirm-forms card">
									<div class="info-text">
										<i class="fa fa-info-circle"></i> Do not
										admit liability
									</div>
									<div class="form-box">
										<Form
											classBinding="row"
											:ref="
												ClaimModel.forms
													.declaration_form.name
											"
											:forms="
												ClaimModel.forms
													.declaration_form.forms
											"
											:form_data="
												ClaimModel.forms
													.declaration_form.data
											"
										/>
									</div>
								</div>
								<div class="buttons">
									<div class="row">
										<div class="col-md-6">
											<div
												class="btn btn-primary btn-long"
												:disabled="loading"
												@click="moveToPreviousReport()"
											>
												Previous
											</div>
										</div>
										<div class="col-md-6">
											<div
												class="btn btn-green btn-long"
												:disabled="loading"
												@click="
													saveClaimReport({
														claimFields:
															$refs[
																claim_report_fields
																	.name
															],
														declaration_form:
															$refs[
																ClaimModel.forms
																	.declaration_form
																	.name
															],
													})
												"
											>
												Save
												<div
													class="lds-ring"
													v-show="loading"
												>
													<div></div>
													<div></div>
													<div></div>
													<div></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<Modal
			:show="showClaimsModal"
			content_class="col-12 col-md-9 col-xl-8 confirm-modal"
		>
			<template slot="content" v-if="selectedClaim">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">View Claim</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showClaimsModal', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="no-padding">
						<div class="row">
							<div class="col-12 col-lg-11 col-xl-10">
								<div class="card card-details">
									<div class="top">
										<div class="icon-box f-l"></div>
										<div class="detail-box f-l">
											<div class="ref">
												Reported On:
												<b>{{
													moment(
														selectedClaim
															.report_details
															.report_date,
													).format('Do MMM YYYY')
												}}</b>
											</div>
											<div class="payment">
												Decision:
												{{
													selectedClaim.claim_decision
												}}
											</div>
											<div class="payment">
												Category Stage:
												{{
													selectedClaim.claim_category_stage
												}}
											</div>
											<div class="payment">
												Claim Type:
												{{ selectedClaim.claim_type }}
											</div>
											<div class="payment">
												Product:
												{{ selectedClaim.product_id }}
											</div>

											<!-- <div class="row">
                        <div class="col-lg-6">
                          <span class="link"><i class="fa fa-users"></i>View Policy</span>
                        </div>
                        <div class="col-lg-6">
                          <span class="link"><i class="fa fa-people-carry"></i>View Risks</span>
                        </div>
                        <div class="col-lg-6">
                          <span class="link"><i class="fa fa-file-invoice-dollar"></i>View Claim Form</span>
                        </div>
                        <div class="col-lg-6">
                          <span class="link"><i class="fa fa-university"></i>View Underwritter</span>
                        </div>
                      </div> -->
										</div>
									</div>

									<hr />

									<Dropdown
										class="fx-dropdown"
										trigger="click"
										@on-click="clickAction($event)"
										placement="bottom-end"
									>
										<div class="btn btn-primary btn-long">
											<i class="fa fa-wrench"></i>
											Actions
											<div
												class="lds-ring"
												v-show="loading"
											>
												<div></div>
												<div></div>
												<div></div>
												<div></div>
											</div>
											<i
												class="fa fa-chevron-down"
												v-show="!loading"
											></i>
										</div>
										<DropdownMenu slot="list">
											<DropdownItem name="add_review">
												<div class="clearfix">
													<i class="fa fa-star"></i>
													<div class="menu-text">
														Add Riview
													</div>
												</div>
											</DropdownItem>
											<DropdownItem name="list_reviews">
												<div class="clearfix">
													<i class="fa fa-list"></i>
													<div class="menu-text">
														List Riviews
													</div>
												</div>
											</DropdownItem>
											<DropdownItem name="add_review">
												<div class="clearfix">
													<i class="fa fa-ban"></i>
													<div class="menu-text">
														Cancel Claims
													</div>
												</div>
											</DropdownItem>
											<DropdownItem name="add_review">
												<div class="clearfix">
													<i
														class="fa fa-retweet"
													></i>
													<div class="menu-text">
														Appeal Rejection
													</div>
												</div>
											</DropdownItem>
											<DropdownItem
												name="make_claim"
												v-if="
													selectedClaim.claim_category_stage ===
													'REPORT'
												"
											>
												<div class="clearfix">
													<i
														class="fa fa-receipt"
													></i>
													<div class="menu-text">
														Make Claim
													</div>
												</div>
											</DropdownItem>
											<span class="title"
												>Claim Views</span
											>
											<DropdownItem name="view_policy">
												<div class="clearfix">
													<i class="fa fa-users"></i>
													<div class="menu-text">
														View Policy
													</div>
												</div>
											</DropdownItem>
											<DropdownItem name="add_review">
												<div class="clearfix">
													<i
														class="fa fa-file-invoice-dollar"
													></i>
													<div class="menu-text">
														View Claim Form
													</div>
												</div>
											</DropdownItem>
											<DropdownItem name="add_review">
												<div class="clearfix">
													<i
														class="fa fa-university"
													></i>
													<div class="menu-text">
														View Underwritter
													</div>
												</div>
											</DropdownItem>
										</DropdownMenu>
									</Dropdown>
								</div>

								<div
									class="service-box"
									v-if="
										selectedClaim.claim_category_stage ===
										'REPORT'
									"
								>
									<div class="h4">Claim Service</div>
									<div class="row">
										<div class="col-lg-4">
											<div
												class="card card-details summary-card"
											>
												<div class="icon">
													<i
														class="fa fa-user-injured"
													></i>
												</div>
												<div class="txt">Hospital</div>
											</div>
										</div>
										<div class="col-lg-4">
											<div
												class="card card-details summary-card"
											>
												<div class="icon">
													<i
														class="fa fa-user-secret"
													></i>
												</div>
												<div class="txt">Police</div>
											</div>
										</div>
										<div class="col-lg-4">
											<div
												class="card card-details summary-card"
											>
												<div class="icon">
													<i
														class="fa fa-truck-loading"
													></i>
												</div>
												<div class="txt">Tow Truck</div>
											</div>
										</div>
									</div>
								</div>

								<div class="tab-box">
									<div class="tab-switch clearfix">
										<div
											class="tab f-l"
											:class="{ active: activeTab == 1 }"
											@click="openTab(1)"
										>
											Claim Process
										</div>
										<div
											class="tab f-l"
											:class="{ active: activeTab == 2 }"
											@click="openTab(2)"
										>
											Notes
										</div>
										<div
											class="tab f-l"
											:class="{ active: activeTab == 3 }"
											@click="openTab(3)"
										>
											Downloads
										</div>
										<div
											class="tab f-l"
											:class="{ active: activeTab == 4 }"
											@click="openTab(4)"
											v-if="
												pending_fields &&
												pending_fields.length > 0
											"
										>
											Additional Info
										</div>
										<div
											class="tab f-l"
											:class="{ active: activeTab == 5 }"
											@click="openTab(5)"
										>
											Actions
										</div>
										<div
											class="tab f-l"
											:class="{ active: activeTab == 6 }"
											@click="openTab(6)"
											v-if="riskDetails"
										>
											Risks
										</div>
										<div
											class="tab f-l"
											:class="{ active: activeTab == 7 }"
											@click="openTab(7)"
											v-if="selectedClaim.claim_details"
										>
											Claim Details
										</div>
									</div>
									<div class="tab-content">
										<div
											class="content-1"
											v-show="activeTab == 1"
										>
											<div class="stages">
												<div
													v-if="
														selectedClaim.claim_process &&
														selectedClaim
															.claim_process
															.length > 0
													"
												>
													<div
														class="stage-container clearfix"
														v-for="(
															stage, index
														) in selectedClaim.claim_process"
														:key="index"
													>
														<div
															class="number f-l"
															:class="{
																success:
																	stage.status ===
																	'completed',
																processing:
																	stage.status ===
																	'processing',
															}"
														>
															<div class="circle">
																{{ index + 1 }}
															</div>
														</div>
														<div class="stage">
															<div class="ref">
																Stage Name:
																{{
																	stage.claim_stage_name
																}}
															</div>
															<div class="ref">
																Stage:
																{{
																	stage.claim_stage_code
																}}
															</div>
															<div
																class="ref tx-grey"
															>
																Description:
																{{
																	stage.claim_stage_description
																}}
															</div>
															<div class="ref">
																Status:
																{{
																	stage.status
																}}
															</div>
															<div class="text">
																Submited On:
																{{
																	moment(
																		stage.start_date,
																	).format(
																		'Do MMM YYYY HH:mm',
																	)
																}}
															</div>
															<div class="text">
																Expected End
																Date:
																{{
																	stage.end_date
																}}
															</div>
														</div>
													</div>
												</div>
												<div
													class="white-content"
													v-if="
														selectedClaim.claim_process &&
														selectedClaim
															.claim_process
															.length === 0
													"
												>
													<div class="title">
														No Stage Process
														Available
													</div>
												</div>
											</div>
										</div>
										<div
											class="content-1"
											v-show="activeTab == 2"
										>
											<div
												v-if="
													selectedClaim.claim_internal_notes &&
													selectedClaim
														.claim_internal_notes
														.length > 0
												"
											>
												<div
													class="note"
													v-for="(
														note, index
													) in selectedClaim.claim_internal_notes"
													:key="index"
												>
													<div class="ref">
														{{ note.created_date }}
													</div>
													<div class="text">
														Subject:
														<b>{{
															note.subject
														}}</b>
													</div>
													<div class="text">
														{{ note.note }}
													</div>
													<div class="text tx-r">
														Created By:
														{{ note.created_by }}
													</div>
												</div>
											</div>
											<div
												class="white-content"
												v-if="
													selectedClaim.claim_internal_notes &&
													selectedClaim
														.claim_internal_notes
														.length === 0
												"
											>
												<div class="title">
													No Notes Available
												</div>
											</div>
										</div>
										<div
											class="content-1"
											v-show="activeTab == 3"
										>
											<div class="no-padding">
												<div
													class="row justify-content-center"
												>
													<div class="col-12">
														<div
															v-if="
																downloads.length >
																0
															"
														>
															<div
																class="certificate clearfix"
																v-for="(
																	doc, j
																) in downloads"
																:key="j"
															>
																<div
																	class="card"
																>
																	<div
																		class="details f-l"
																	>
																		<div
																			class="name"
																		>
																			{{
																				doc.document_name
																			}}
																		</div>
																		<div
																			class="type clearfix"
																		>
																			<div
																				class="txt f-l"
																			>
																				Type:
																			</div>
																			<span
																				class="status f-l info"
																				>{{
																					doc.document_ref
																				}}</span
																			>
																			<!-- <span class="status f-l info">{{doc.type}}</span> -->
																		</div>

																		<div
																			class="categories clearfix"
																		>
																			<div
																				class="category f-l"
																			>
																				<div
																					class="date f-l"
																				>
																					Issue
																					Date:
																					{{
																						doc.created_date
																					}}
																				</div>
																			</div>
																		</div>
																	</div>
																	<div
																		class="action-box"
																	>
																		<a
																			:href="
																				api.getDomain() +
																				doc.document_path
																			"
																			target="_blank"
																			class="download"
																		>
																			<i
																				class="fa fa-download"
																			></i>
																		</a>
																	</div>
																</div>
															</div>
														</div>

														<div
															class="white-content"
															v-if="
																downloads.length ===
																0
															"
														>
															<div class="title">
																No Documents
																Available
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											class="content-1"
											v-show="activeTab == 4"
											v-if="
												pending_fields &&
												pending_fields.length > 0
											"
										>
											<div class="no-padding">
												<div
													class="row justify-content-center"
												>
													<div
														class="col-12 col-lg-11"
													>
														<div
															class="p-field clearfix"
															v-for="(
																field, f
															) in pending_fields"
															:key="f"
															@click="
																generateAdditionalInfoForm(
																	{
																		pending_forms:
																			field.form_fields,
																		form_ref:
																			field.ad_info_ref,
																	},
																)
															"
														>
															<div
																class="icon f-l"
															>
																<i
																	class="fa fa-text-width"
																	v-if="
																		!field.ad_info_icon ||
																		field.ad_info_icon ===
																			''
																	"
																></i>
																<i
																	class="fa"
																	:class="`fa-${field.ad_info_icon}`"
																	v-else
																></i>
															</div>
															<div
																class="text-box f-l"
															>
																<div
																	class="title"
																>
																	{{
																		field.ad_info_name
																	}}
																</div>
																<div
																	class="desc"
																>
																	{{
																		field.ad_info_description
																	}}
																</div>
																<div
																	class="desc"
																>
																	{{
																		field.ad_info_field_code
																	}}
																</div>
															</div>
														</div>

														<div
															class="white-content"
															v-if="
																pending_fields.length ===
																0
															"
														>
															<div class="title">
																No Pending
																Fields Found
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											class="content-1"
											v-show="activeTab == 5"
										>
											<div class="no-padding">
												<div
													class="questions"
													v-if="actions.length > 0"
												>
													<div
														class="question-box card card-details"
														v-for="(
															action, a
														) in actions"
														:key="a"
													>
														<div class="question">
															{{
																action.claim_action_description
															}}
														</div>

														<div class="row">
															<div
																class="col-md-6"
															>
																<div
																	class="btn btn-red btn-long"
																	@click="
																		submitClaimAction(
																			{
																				action_ref:
																					action.claim_action_ref,
																				value: 1,
																			},
																		)
																	"
																>
																	NO
																	<div
																		class="lds-ring"
																		v-show="
																			loading
																		"
																	>
																		<div></div>
																		<div></div>
																		<div></div>
																		<div></div>
																	</div>
																</div>
															</div>
															<div
																class="col-md-6"
															>
																<div
																	class="btn btn-green btn-long"
																	@click="
																		submitClaimAction(
																			{
																				action_ref:
																					action.claim_action_ref,
																				value: 0,
																			},
																		)
																	"
																>
																	YES
																	<div
																		class="lds-ring"
																		v-show="
																			loading
																		"
																	>
																		<div></div>
																		<div></div>
																		<div></div>
																		<div></div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div
													class="white-content"
													v-if="actions.length === 0"
												>
													<div class="title">
														No Pending Actions
														Found!
													</div>
												</div>
											</div>
										</div>
										<div
											class="content-1"
											v-show="activeTab == 6"
											v-if="riskDetails"
										>
											<div class="no-padding">
												<div class="risk-title">
													Risk Details
												</div>
												<div
													class="card card-details"
													v-if="
														riskDetails.risk_details
													"
												>
													<div class="risk-item row">
														<div
															class="key col-lg-5"
														>
															Risk System Ref
														</div>
														<div
															class="val tx-uppercase col-lg-7"
														>
															{{
																riskDetails.risk_system_ref
															}}
														</div>
													</div>
													<div
														class="risk-item clearfix row"
													>
														<div
															class="key col-lg-5"
														>
															Sum Assured
														</div>
														<div
															class="val col-lg-7"
														>
															{{
																riskDetails.sum_assured
															}}
														</div>
													</div>
													<div
														class="risk-item clearfix row"
														v-for="(
															detail, i
														) of Object.entries(
															riskDetails.risk_details,
														)"
														:key="i"
													>
														<div
															class="key col-lg-5"
														>
															{{ detail[0] }}
														</div>
														<div
															class="val col-lg-7"
														>
															{{ detail[1] }}
														</div>
													</div>
												</div>

												<div class="risk-title">
													Risk Documents
												</div>
												<div
													v-if="
														riskDetails
															.risk_documents
															.length > 0
													"
												>
													<div
														class="certificate clearfix"
														v-for="(
															doc, j
														) in riskDetails.risk_documents"
														:key="j"
													>
														<div class="card">
															<div
																class="details f-l"
															>
																<div
																	class="name"
																>
																	{{
																		doc.document_name
																	}}
																</div>
																<div
																	class="type clearfix"
																>
																	<div
																		class="txt f-l"
																	>
																		Ref:
																	</div>
																	<span
																		class="status f-l info"
																		>{{
																			doc.document_ref
																		}}</span
																	>
																	<!-- <span class="status f-l info">{{doc.type}}</span> -->
																</div>

																<div
																	class="categories clearfix"
																>
																	<div
																		class="category f-l"
																	>
																		<div
																			class="date f-l"
																		>
																			Issue
																			Date:
																			{{
																				doc.document_date
																			}}
																		</div>
																	</div>
																</div>
															</div>
															<div
																class="action-box"
															>
																<a
																	:href="
																		api.getDomain() +
																		doc.document_path
																	"
																	target="_blank"
																	class="download"
																>
																	<i
																		class="fa fa-download"
																	></i>
																</a>
															</div>
														</div>
													</div>
												</div>

												<div
													class="white-content"
													v-if="
														downloads.length === 0
													"
												>
													<div class="title">
														No Documents Available
													</div>
												</div>

												<div class="risk-title">
													Risk Images
												</div>
												<div
													v-if="
														riskDetails.risk_images
															.length > 0
													"
												>
													<div
														class="certificate clearfix"
														v-for="(
															image, j
														) in riskDetails.risk_images"
														:key="j"
													>
														<div class="card">
															<div
																class="details f-l"
															>
																<div
																	class="image-side"
																>
																	<img
																		:src="
																			image.image_path ===
																			''
																				? '/img/logo-1.png'
																				: api.getDomain() +
																					image.image_path
																		"
																		alt="image_name"
																		srcset=""
																	/>
																</div>
																<div
																	class="text-side"
																>
																	<div
																		class="name"
																	>
																		{{
																			image.image_name
																		}}
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>

												<div
													class="white-content"
													v-if="
														downloads.length === 0
													"
												>
													<div class="title">
														No Images Available
													</div>
												</div>
											</div>
										</div>
										<div
											class="content-1"
											v-show="activeTab == 7"
											v-if="selectedClaim.claim_details"
										>
											<div class="no-padding">
												<div class="risk-title">
													Risk Details
												</div>
												<div
													class="card card-details"
													v-if="
														selectedClaim.claim_details
													"
												>
													<div
														class="risk-item clearfix row"
														v-for="(
															detail, i
														) of Object.entries(
															selectedClaim.claim_details,
														)"
														:key="i"
													>
														<div
															class="key col-lg-5"
														>
															{{ detail[0] }}
														</div>
														<div
															class="val col-lg-7"
														>
															{{ detail[1] }}
														</div>
													</div>
												</div>

												<div class="risk-title">
													Risk Documents
												</div>
												<div
													v-if="
														selectedClaim
															.claim_documents
															.length > 0
													"
												>
													<div
														class="certificate clearfix"
														v-for="(
															doc, j
														) in selectedClaim.claim_documents"
														:key="j"
													>
														<div class="card">
															<div
																class="details f-l"
															>
																<div
																	class="name"
																>
																	{{
																		doc.document_name
																	}}
																</div>
																<div
																	class="type clearfix"
																>
																	<div
																		class="txt f-l"
																	>
																		Ref:
																	</div>
																	<span
																		class="status f-l info"
																		>{{
																			doc.document_ref
																		}}</span
																	>
																	<!-- <span class="status f-l info">{{doc.type}}</span> -->
																</div>

																<div
																	class="categories clearfix"
																>
																	<div
																		class="category f-l"
																	>
																		<div
																			class="date f-l"
																		>
																			Issue
																			Date:
																			{{
																				doc.document_date
																			}}
																		</div>
																	</div>
																</div>
															</div>
															<div
																class="action-box"
															>
																<a
																	:href="
																		api.getDomain() +
																		doc.document_path
																	"
																	target="_blank"
																	class="download"
																>
																	<i
																		class="fa fa-download"
																	></i>
																</a>
															</div>
														</div>
													</div>
												</div>

												<div
													class="white-content"
													v-if="
														downloads.length === 0
													"
												>
													<div class="title">
														No Documents Available
													</div>
												</div>

												<div class="risk-title">
													Risk Images
												</div>
												<div
													v-if="
														selectedClaim
															.claim_images
															.length > 0
													"
												>
													<div
														class="certificate clearfix"
														v-for="(
															image, j
														) in selectedClaim.claim_images"
														:key="j"
													>
														<div class="card">
															<div
																class="details f-l"
															>
																<div
																	class="image-side"
																>
																	<img
																		:src="
																			image.image_path ===
																			''
																				? '/img/logo-1.png'
																				: api.getDomain() +
																					image.image_path
																		"
																		alt="image_name"
																		srcset=""
																	/>
																</div>
																<div
																	class="text-side"
																>
																	<div
																		class="name"
																	>
																		{{
																			image.image_name
																		}}
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>

												<div
													class="white-content"
													v-if="
														downloads.length === 0
													"
												>
													<div class="title">
														No Images Available
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<Modal
			:show="showMakeClaimsModal"
			content_class="col-12 col-md-8 col-lg-7 col-xl-6 confirm-modal"
		>
			<template slot="content" v-if="makeClaimModel">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">Make Claim</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showMakeClaimsModal', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="content">
						<div class="steps">
							<div class="page" v-if="claim_page === 1">
								<div class="forms">
									<div class="h4">Select Claim Type</div>

									<div class="page-box">
										<div class="scroll-content">
											<scrollbar>
												<div
													class="select-card claim-type card card-details"
													v-for="(
														claim_type, c
													) in claim_types"
													:key="c"
													@click="
														$store.commit(
															'selected_claim_type',
															claim_type.claim_type_code,
														);
														$store.commit(
															'selected_claim_type_name',
															claim_type.claim_type_name,
														);
													"
													:class="{
														selected:
															claim_type.claim_type_code ===
															selected_claim_type,
													}"
												>
													<div class="clearfix">
														<div class="f-l">
															<img
																:src="
																	claim_type.claim_type_icon &&
																	claim_type.claim_type_icon !==
																		''
																		? api.getDomain() +
																			claim_type.claim_type_icon
																		: '/img/logo-1.png'
																"
																alt=""
																class="image"
															/>
														</div>
														<div class="f-l">
															<div class="name">
																{{
																	claim_type.claim_type_name
																}}
															</div>
															<div class="desc">
																{{
																	claim_type.claim_type_description
																}}
															</div>
														</div>
													</div>
												</div>
											</scrollbar>
										</div>
									</div>
								</div>
								<div class="buttons">
									<div
										class="row"
										v-show="
											selectedClaim.policy_business_type &&
											selectedClaim.policy_business_type ===
												'INTERMEDIARY'
										"
									>
										<div class="col-12 col-lg-6">
											<div
												class="btn btn-primary btn-long"
												:disabled="loading"
												@click="
													moveToNextMakeClaim({
														type: 'intermediary',
													})
												"
											>
												Submit via Intermediary
												<div
													class="lds-ring"
													v-show="loading"
												>
													<div></div>
													<div></div>
													<div></div>
													<div></div>
												</div>
											</div>
										</div>
										<div class="col-12 col-lg-6">
											<div
												class="btn btn-green btn-long"
												:disabled="loading"
												@click="
													moveToNextMakeClaim({
														type: 'direct',
													})
												"
											>
												Submit to Underwritter
												<div
													class="lds-ring"
													v-show="loading"
												>
													<div></div>
													<div></div>
													<div></div>
													<div></div>
												</div>
											</div>
										</div>
									</div>
									<div
										class="row"
										v-show="
											!selectedClaim.policy_business_type
										"
									>
										<div class="col-12">
											<div
												class="btn btn-green btn-long"
												:disabled="loading"
												@click="
													moveToNextMakeClaim({
														type: 'direct',
													})
												"
											>
												Submit to Underwritter
												<div
													class="lds-ring"
													v-show="loading"
												>
													<div></div>
													<div></div>
													<div></div>
													<div></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="page" v-if="claim_page === 2">
								<div class="forms">
									<div
										class="form-box"
										v-if="
											claim_report_fields.forms &&
											claim_report_fields.forms.length > 0
										"
									>
										<Form
											classBinding="row"
											:ref="claim_report_fields.name"
											:forms="claim_report_fields.forms"
											:form_data="
												claim_report_fields.data
											"
											@file-selected="uploadFilesClaim"
										/>
									</div>

									<div class="white-content" v-else>
										<div class="title">
											No Forms Fields Found!
										</div>
									</div>
								</div>
								<div class="buttons">
									<div class="row">
										<div class="col-md-6">
											<div
												class="btn btn-primary btn-long"
												:disabled="loading"
												@click="
													moveToPreviousMakeClaim()
												"
											>
												Previous
											</div>
										</div>
										<div class="col-md-6">
											<div
												class="btn btn-success btn-long"
												:disabled="loading"
												@click="
													saveClaimReport({
														claimFields:
															$refs[
																claim_report_fields
																	.name
															],
														make_claim: true,
													})
												"
											>
												Save
												<div
													class="lds-ring"
													v-show="loading"
												>
													<div></div>
													<div></div>
													<div></div>
													<div></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<Modal
			:show="showSubmitAdditionalInfo"
			content_class="col-12 col-md-7 col-lg-6 col-xl-5 confirm-modal"
		>
			<template slot="content" v-if="AdditionalInfoModel">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">
								Provide Additional Info
							</div>
						</div>
						<div
							class="close-modal f-r"
							@click="
								$store.commit('showSubmitAdditionalInfo', false)
							"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="content">
						<div class="forms">
							<div
								class="form-box"
								v-if="
									AdditionalInfoModel.forms &&
									AdditionalInfoModel.forms.length > 0
								"
							>
								<Form
									classBinding="row"
									:ref="AdditionalInfoModel.name"
									:forms="AdditionalInfoModel.forms"
									:form_data="AdditionalInfoModel.data"
									@file-selected="uploadFilesClaim"
								/>
							</div>

							<div class="white-content" v-else>
								<div class="title">No Forms Fields Found!</div>
							</div>
						</div>
						<div>
							<div
								class="btn btn-primary btn-long"
								:disabled="loading"
								@click="
									saveAdditionalInfo({
										ref: $refs[AdditionalInfoModel.name],
									})
								"
							>
								Save
								<div class="lds-ring" v-show="loading">
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<Modal
			:show="showRisksModal"
			content_class="col-12 col-md-7 col-lg-6 col-xl-5 confirm-modal"
		>
			<template slot="content" v-if="makeClaimModel">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">Risks</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showRisksModal', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="content">
						<div class="risks" v-if="risks.length > 0">
							<div
								class="select-card policy card card-details"
								v-for="(risk, p) in risks"
								:key="p"
								@click="
									$store.commit('selected_risk', risk.risk_id)
								"
								:class="{
									selected: risk.risk_id === selected_risk,
								}"
							>
								<div class="clearfix">
									<div class="f-l">
										<div class="name">
											Sum Assured: {{ risk.sum_assured }}
										</div>
										<div class="cover-date">
											Premium Amount:
											{{ risk.premium_amount }}
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="white-content" v-else>
							<div class="title">No Risks Found!</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<Modal
			:show="showClaimCancelationModal"
			content_class="col-12 col-md-7 col-lg-6 col-xl-5 confirm-modal"
		>
			<template slot="content">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">Cancel Policy</div>
						</div>
						<div
							class="close-modal f-r"
							@click="
								$store.commit(
									'showClaimCancelationModal',
									false,
								)
							"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="content">
						<div class="risks">
							<Form
								classBinding="row"
								:ref="
									ClaimModel.forms.policy_cancelation_remarks
										.name
								"
								:forms="
									ClaimModel.forms.policy_cancelation_remarks
										.forms
								"
								:form_data="
									ClaimModel.forms.policy_cancelation_remarks
										.data
								"
							/>

							<div
								class="btn btn-primary btn-long"
								:disabled="loading"
								@click="
									cancelPolicy({
										ref: $refs[
											ClaimModel.forms
												.policy_cancelation_remarks.name
										],
									})
								"
							>
								Save
								<div class="lds-ring" v-show="loading">
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<AddReview />
		<ShowReviews></ShowReviews>
	</div>
</template>

<script>
import VueScrollbar from 'vue-scrollbar-simple';

export default {
	components: {
		Form: () => import('@/libs/clarks/components/form'),
		Modal: () => import('@/components/newportal/templates/others/modal'),
		Dropdown: () => import('@/libs/clarks/components/dropdown/dropdown'),
		DropdownItem: () =>
			import('@/libs/clarks/components/dropdown/dropdown-item'),
		DropdownMenu: () =>
			import('@/libs/clarks/components/dropdown/dropdown-menu'),
		AddReview: () => import('./review'),
		ShowReviews: () => import('./list-reviews'),
		scrollbar: VueScrollbar,
	},
	computed: {
		...mapGetters([
			'loading',
			'showClaimsModal',
			'showSubmitAdditionalInfo',
			'showMakeClaimsModal',
			'showRisksModal',
			'showReportIncident',
			'selectedClaim',
			'selected_policy',
			'claim_types',
			'pending_fields',
			'submited_fields',
			'selected_claim_type',
			'activeTab',
			'risks',
			'actions',
			'selected_risk',
			'claim_policies',
			'report_page',
			'claim_page',
			'downloads',
			'showClaimCancelationModal',
			'benefit_name',
			'makeClaimModel',
			'selected_claim_type_name',
			'ClaimModel',
			'AdditionalInfoModel',
			'riskDetails',
			'claim_report_fields',
		]),
	},
	data() {
		return {
			api,
			utils,
			moment,
		};
	},
	methods: {
		...mapActions([
			'requestIPF',
			'payIPF',
			'openTab',
			'saveClaimReport',
			'makeClaim',
			'saveAdditionalInfo',
			'fetchRisks',
			'cancelPolicy',
			'generateAdditionalInfoForm',
			'fetchClaimReviews',
			'moveToNextReport',
			'submitClaimAction',
			'submitReview',
			'moveToPreviousReport',
			'moveToNextMakeClaim',
			'moveToPreviousMakeClaim',
			'uploadFilesClaim',
			'saveClaims',
		]),
		async clickAction(action) {
			try {
				this.$store.commit('loading', true);
				switch (action) {
					case 'add_review':
						this.$store.commit('showAddReviews', true);
						break;
					case 'list_reviews':
						await this.fetchClaimReviews();
						this.$store.commit('showListReview', true);
						break;
					case 'view_risks':
						await this.fetchPolicyRisks();
						this.$store.commit('showRisksModal', true);
						break;
					case 'cancel_policy':
						this.$store.commit('showClaimCancelationModal', true);
						this.$store.commit('loading', false);
						break;
					case 'make_claim':
						this.$store.commit('loading', false);
						await this.makeClaim();
						break;
					case 'view_policy':
						this.$router.push({
							name: 'UserProducts',
							params: {
								id: this.selectedClaim.client_product_id,
							},
						});
						break;

					default:
						break;
				}

				this.$store.commit('loading', false);
			} catch (error) {
				this.$store.commit('loading', false);
			}
		},
	},
	mounted() {},
};
</script>

<style lang="less">
@grey: #a7abbd;

.view-claim {
	.scroll-content {
		height: calc(100vh - 250px);
	}

	.image-side {
		width: 30%;
		text-align: center;
		float: left;
		margin: 0 0 0 0;
		max-height: 60px;

		img {
			width: auto;
			height: auto;
			max-width: 100%;
			max-height: 60px;
		}
	}
	.text-side {
		float: left;
		margin: 10px 0 0 20px;
	}
	.risk-title {
		font-weight: 600;
	}
	.risk-item {
		margin: 5px 0;

		.tx-uppercase {
			text-transform: uppercase;
		}
		.key {
			font-weight: 600;
		}

		.val {
		}
	}
	.question-box {
		.question {
			font-weight: 600;
			text-transform: uppercase;
			font-size: 13px;
			margin: 5px 0 10px 10px;
		}
	}
	.certificate {
		background: #f5f9fb;
		padding: 0 15px;
		border-radius: 3px;

		.card {
			margin: 20px 0 !important;
		}
		.download {
			color: var(--text-color);
		}
		.download:hover {
			color: var(--ne-red);
		}
		.name {
			font-size: 15px;
			font-weight: 600;
		}
		.action-box {
			margin: 12px 15px 0 0;
			text-align: center;
			font-size: 17px;
			cursor: pointer;
			position: absolute;
			right: 10px;
			top: 10px;
		}
		.action-box:hover {
			color: var(--ne-red);
		}
		.details {
			.txt {
				font-size: 15px;
				font-family: var(--font-bold);
			}
			.status {
				background: var(--ne-blue);
				color: var(--white);
				display: inline-block;
				padding: 3px 5px;
				font-size: 10px;
				line-height: 12px;
				border-radius: 3px;
				text-transform: uppercase;
				font-weight: 600;
				margin: 4px 0 0 10px;
			}
			.success {
				background: var(--ne-green);
			}
			.categories {
				line-height: 10px;
				margin: 8px 0 12px 0;

				.date {
					color: var(--text-grey);
					font-size: 13px;
				}
				.circle {
					width: 4px;
					height: 4px;
					border-radius: 50%;
					background: var(--text-grey);
					margin: 2px 7px 0 7px;
				}
			}
			.category:last-child {
				.circle {
					display: none;
				}
			}
		}
	}
	.confirm-forms {
		.info-text {
			font-size: 13px;
			font-weight: 600;
			margin: 15px 0;
		}
	}

	.p-field {
		margin: 0 0 5px 0;
		border-bottom: solid 1px var(--border-grey);
		padding: 5px 0;
		cursor: pointer;

		.icon {
			font-size: 24px;
			margin: 0 10px 0 0;
			width: 30px;
		}

		.title {
			font-weight: 600;
			font-size: 13px;
			text-transform: uppercase;
		}

		.desc {
			font-size: 13px;
		}
	}
	.forms .white-content {
		margin: 20px 10px;
	}
	.white-content {
		background: var(--white);
		border-radius: 4px;
		border: solid 1px #e6eaee;
		padding: 40px 0;
		text-align: center;
		font-size: 14px;
		font-weight: 600;
		color: var(--ne-red);
	}

	.page-box {
		margin: 20px 0;
	}
	.select-card {
		cursor: pointer;
		.image {
			max-width: 90px;
			max-height: 90px;
			width: auto;
			height: auto;
			margin: 5px 15px 0 0;
		}

		&.selected {
			background-color: rgba(220, 220, 220, 0.3) !important;
		}

		&.policy {
			.name {
				font-size: 12px;
				text-transform: uppercase;
				font-weight: 600;
			}
			.amount {
				font-weight: 600;
			}
			.cover-date {
				font-size: 12px;
				font-weight: 600;
			}
		}
		&.claim-type {
			.name {
				font-size: 13px;
				text-transform: uppercase;
				font-weight: 600;
			}
			.desc {
				font-size: 12px;
			}
		}
	}

	.h4 {
		font-weight: 600;
		font-size: 13px;
		text-transform: uppercase;
		color: var(--primary);
		margin: 5px 0 0 0;
	}
	.summary-card {
		padding: 10px;
		text-align: center;
		margin: 5px 0;
		cursor: pointer;

		.icon {
			font-size: 32px;
			font-family: var(--font-bolder);
		}
		.txt {
			font-weight: 600;
			margin: 3px 0 0 0;
			font-size: 13px;
			text-transform: uppercase;
		}
	}

	.link {
		font-size: 12px;
		font-weight: 600;
		color: var(--primary);
		cursor: pointer;

		.fa {
			width: 20px;
			text-align: center;
			margin: 5px;
		}
		&:hover {
			text-decoration: underline;
		}
	}
	.note {
		background: var(--white);
		border-radius: 3px;
		border: solid 1px #fefefe;
		padding: 15px;
		margin: 10px;

		.text {
			font-size: 13px;
		}
	}
	.stages {
		.stage-container {
			position: relative;

			&:first-child {
				.number {
					margin-top: 30px;

					.circle {
						margin-top: -20px;
					}
				}
			}
			&:last-child {
				.number {
					margin-bottom: 90px;

					.circle {
						margin-bottom: -20px;
					}
				}
			}

			.number {
				border-left: solid 2px var(--red);
				position: absolute;
				top: 0;
				bottom: 0;

				.circle {
					margin: 10px 0 0 -17px;
					width: 30px;
					height: 30px;
					border: solid 2px var(--red);
					color: var(--red);
					padding: 4px 0 0 0;
					text-align: center;
					font-size: 15px;
					font-weight: 600;
					border-radius: 50%;
					background: var(--white);
				}

				&.success {
					border-left-color: var(--ne-green);

					.circle {
						border: solid 2px var(--ne-green);
						color: var(--ne-green);
					}
				}
				&.processing {
					border-left-color: var(--primary);

					.circle {
						border: solid 2px var(--primary);
						color: var(--primary);
					}
				}
			}

			.stage {
				background: var(--white);
				// color: var(--white);
				float: left;
				width: calc(100% - 60px);
				padding: 15px;
				margin: 10px 10px 10px 50px;
				border-radius: 3px;
				font-size: 14px;
				font-weight: 600;
			}
		}
	}
	.ref {
		font-size: 13px;
	}
	.payment {
		font-size: 14px;
		font-weight: 600;
	}
	.status {
		color: var(--ne-green);
		font-size: 14px;
		font-weight: 600;
	}

	.transactions {
		margin: 30px -30px 20px -30px;
	}
}
</style>
